import { useLocation } from 'react-router-dom';
import qs from 'query-string';

export function useQuery<T>() {
  const location = useLocation();

  return qs.parse(location.search) as Partial<T>;
}
